// Mock data for Imani Food Restaurant

export const restaurantInfo = {
  name: "Imani Food",
  address: "Espl. des Récréations 22, 1217 Meyrin",
  phone: "079 913 54 25",
  priceRange: "CHF 10–20 per person",
  rating: 4.5,
  totalReviews: 11
};

export const hours = {
  Monday: "12–10 pm",
  Tuesday: "12–10 pm", 
  Wednesday: "12–10 pm",
  Thursday: "12–10 pm",
  Friday: "12 pm–12 am",
  Saturday: "12 pm–12 am",
  Sunday: "11 am–9 pm"
};

export const services = [
  { name: "Delivery", available: true },
  { name: "Takeaway", available: true },
  { name: "Dine-in", available: true },
  { name: "Reservations", available: true },
  { name: "Wheelchair Accessible", available: true },
  { name: "Good for Kids", available: true }
];

export const menuCategories = [
  {
    id: "accompaniments",
    name: "Accompagnements", 
    items: [
      { name: "Chikwanga", price: "5.00", description: "Pain fermenté préparé à partir de manioc et enveloppé dans des feuilles de bananier." },
      { name: "Frites de Manioc", price: "6.00", description: "Pour changer des éternelles frites, ses frites de manioc ultra croustillantes." },
      { name: "Foutou à la banane", price: "7.00", description: "Le foutou de banane, excellent accompagnement des sauces africaines.", popular: true },
      { name: "Attiéké", price: "6.00", description: "La célèbre semoule de manioc surnommée \"couscous de côte d'ivoire\"." },
      { name: "Placali", price: "7.00", description: "Pâte de manioc fermentée d'origine ivoirienne.", popular: true },
      { name: "Foufou Maïs à la Congolaise", price: "7.00", description: "Découvrez nos foufou maïs cuisiner à la congolaise.", popular: true }
    ]
  },
  {
    id: "entrees", 
    name: "Entrées",
    items: [
      { name: "Accra de Mourue", price: "7.00", description: "Délicieux accras de morue antillais chauds et croustillants." },
      { name: "Crevettes au miel de Casamance", price: "14.00", description: "Crevette caramélisé aux épices d'afrique et miel du congo." },
      { name: "Fataya", price: "9.00", description: "Délicieux beignet africain farci à la viande. (6 Fataya)", popular: true },
      { name: "Kamudelé Brochettes de Bœuf", price: "14.00", description: "Brochettes marinées avec nos épices d'Afrique. (4 Brochettes)" }
    ]
  },
  {
    id: "poultry",
    name: "Volailles", 
    items: [
      { name: "Poulet Mayo", price: "17.00", description: "Délicieuse recette venue tout droit de Kinshasa.", popular: true },
      { name: "Poulet Mariné Miel et Moutarde", price: "17.00", description: "Cuisses de poulet au miel mariné citron." },
      { name: "Poulet à la Moambé", price: "18.00", description: "Ragoût de poulet avec beurre de palme et épices." },
      { name: "Thiep au Poulet", price: "26.00", description: "Plat sénégalais à base de riz, sauce tomate, poulet et légumes." }
    ]
  },
  {
    id: "meat",
    name: "Viandes",
    items: [
      { name: "Mafé à la Viande Bœuf", price: "28.00", description: "Ragoût à base de pâte d'arachide, viande, légumes et riz.", popular: true },
      { name: "Nongo Nongo à la Queue de Bœuf", price: "28.00", description: "Sauce gombo gluante à base de gombos frais." },
      { name: "Ntaba la Délicatesse Grillée", price: "20.00", description: "Viande de chèvre grillée avec goût fumé." }
    ]
  },
  {
    id: "fish",
    name: "Poissons",
    items: [
      { name: "Soupou Kandia", price: "29.00", description: "Ragoût aux gombos et à l'huile de palme avec riz créole." },
      { name: "Poisson Braisé", price: "22.00", description: "Poisson tilapia assaisonné avec épices d'Afrique." },
      { name: "Akpessi", price: "28.00", description: "Poisson tilapia, banane plantain, manioc et légumes." }
    ]
  },
  {
    id: "vegetables",
    name: "Plats aux Légumes",
    items: [
      { name: "Pondu Ragoût de Légumes", price: "18.00", description: "Préparé avec jus de coco, peut être consommé avec manioc, pain ou riz." },
      { name: "Madesu Haricot", price: "17.00", description: "Riz cuit et haricots avec exhausteurs de goût.", popular: true },
      { name: "Fumbwa Ragoût Congolais", price: "18.00", description: "Ragoût d'épinards sauvages, art culinaire congolais." }
    ]
  },
  {
    id: "desserts",
    name: "Desserts",
    items: [
      { name: "Mikaté Beignet au Sucre", price: "6.00", description: "Délicieux beignets ronds et dorés d'Afrique.", popular: true },
      { name: "Sombi Riz au Lait Caramel", price: "6.00", description: "Riz au lait fondant avec sauce caramel beurre salé." },
      { name: "Cheesecake Framboise", price: "8.00", description: "Délicieux cheesecake framboise fait maison." },
      { name: "Fondant Chocolat Beurre Salé", price: "8.00", description: "Fondant chocolat beurre salé fait maison." }
    ]
  },
  {
    id: "beverages", 
    name: "Boissons",
    items: [
      { name: "Jus de Tangawizi", price: "6.00", description: "Jus de gingembre et citron traditionnel du Congo." },
      { name: "Jus de Bissap Exotique", price: "6.00", description: "Boisson à partir de fleurs d'hibiscus avec fruits." },
      { name: "Jus de Baobab", price: "7.00", description: "Jus préparé à partir de la pulpe du fruit du baobab." },
      { name: "Smoothie Baobab Mangue", price: "7.00", description: "Baobab, mangue, lait de coco et banane." }
    ]
  }
];

export const reviews = [
  {
    name: "Noelie Castellazzi",
    rating: 5,
    text: "Just delicious food as soon as I have the opportunity I order so in any case 2-3 times a month the quality price ratio is just perfect. She is a just lovely person and she advises the best according to everyone's tastes.",
    timeAgo: "2 years ago"
  },
  {
    name: "Gatete Karege", 
    rating: 5,
    text: "Great experience! Order made for 15 people. Very easy and fast communication on WhatsApp. Home delivery at no extra cost. Excellent dishes (I recommend the plantains)!",
    timeAgo: "a year ago"
  },
  {
    name: "Vincent",
    rating: 5, 
    text: "A wonderful discovery, a warm welcome, and a hearty meal with lots of flavor. I'm used to eating African food, and I can tell you it's delicious. Plus, a portion of the profits go to fund humanitarian projects.",
    timeAgo: "2 years ago"
  },
  {
    name: "Sophie Galli",
    rating: 5,
    text: "Delicious cuisine that stands out from the dishes usually found in Geneva. The plates are generous and tasty. An excellent place to go on a culinary journey.",
    timeAgo: "a year ago" 
  }
];

export const featuredDishes = [
  {
    name: "Foutou à la banane",
    price: "7.00",
    description: "Le foutou de banane, excellent accompagnement des sauces africaines.",
    badge: "#1 most liked"
  },
  {
    name: "Foufou Maïs à la Congolaise", 
    price: "7.00",
    description: "Découvrez nos foufou maïs cuisiner à la congolaise.",
    badge: "#2 most liked"
  },
  {
    name: "Placali",
    price: "7.00", 
    description: "Pâte de manioc fermentée d'origine ivoirienne.",
    badge: "#3 most liked"
  }
];